export default __webpack_public_path__ + "locales/bg/Common.json?hash=f91a7240bca9e93c6d0d28ac741cffc6";